export const HEALTHCARE_REGISTRATION = `${import.meta.env.VITE_API_BASE_URL}/establishment-registration`

export const HEALTHCARE_FILTERED = (establishment_id?: string) =>
  `${HEALTHCARE_REGISTRATION}/${establishment_id}`

export const HOSPITAL_CREDENTIALS = (establishmentId: string) =>
  `${HEALTHCARE_REGISTRATION}/${establishmentId}/credentials`

export const ROTATE_HOSPITAL_CREDENTIALS = (establishmentId: string) =>
  `${HOSPITAL_CREDENTIALS(establishmentId)}/rotate`

export const HEALTHCARE_PROFESSIONAL_RELATION = `${import.meta.env.VITE_API_BASE_URL}/establishment-professional-relation`

export const HEALTHCARE_PATIENT_RELATION = `${import.meta.env.VITE_API_BASE_URL}/establishment-patient-relation`

export const HEALTHCARE_LIST_OF_PROFESSIONAL = (professional_id?: string) =>
  `${HEALTHCARE_PROFESSIONAL_RELATION}/establishment/${professional_id}`

export const PROFESSIONAL_LIST_OF_HEALTHCARE = (establishment_id?: string) =>
  `${HEALTHCARE_PROFESSIONAL_RELATION}/professional/${establishment_id}`

export const HEALTHCARE_LIST_OF_PATIENT = (patient_id?: string) =>
  `${HEALTHCARE_PATIENT_RELATION}/establishment/${patient_id}`

export const PATIENT_LIST_OF_HEALTHCARE = (
  establishment_id?: string,
  listType?: 'active' | 'success' | 'discarded' | null
) => {
  if (typeof listType == 'string') {
    return `${HEALTHCARE_PATIENT_RELATION}/patient/${establishment_id}/${listType}`
  }
  return `${HEALTHCARE_PATIENT_RELATION}/patient/${establishment_id}`
}

export const TOGGLE_HEALTHCARE_PERMISSION_BATCH = `${import.meta.env.VITE_API_BASE_URL}/establishment-module-permissions/batch-toggle`

export const HEALTHCARE_LOGO = (establishment_id?: string) =>
  `${import.meta.env.VITE_API_BASE_URL}/establishment-logo/${establishment_id}`
